import { AuthProvider } from '@/features/auth';
import { Gallery } from '@/features/catalog';
import { Header } from './Header';
import { Hero } from './Hero';
import { Footer } from './Footer';
import { About } from './About';
import styles from './App.module.css';

export function App() {
  return (
    <AuthProvider>
      <Header />
      <main className={styles.main}>
        <Hero />
        <Gallery />
        <About />
      </main>
      <Footer />
    </AuthProvider>
  );
}
